'use client';
import { useRouter } from 'next/navigation';
import Button from '../components/ui/Button';
import { openCalendly } from '@/lib/ctaRouting';
import { trackDiscoveryCallClick } from '@/lib/analytics';
import { getUserContext } from '@/lib/userContext';

export default function TimelineSection() {
  const router = useRouter();

  const handleStartTimeline = () => {
    router?.push('/register');
  };

  const handleTalkGoals = () => {
    getUserContext()?.then(context => {
      const segment = context?.role || 'unauthenticated';
      trackDiscoveryCallClick(
        segment === 'super_admin' ? 'super_admin' : 
        segment === 'ops_admin' || segment === 'admin' ? 'admin' : 
        segment === 'team' ? 'team' : 
        segment === 'client' ? 'client' : 'unauthenticated',
        '/',
        'timeline'
      );
    });
    openCalendly();
  };

  const timelineData = [
    {
      month: "Month 1",
      description: "Fix, clean up, and stabilize your creative output."
    },
    {
      month: "Month 2",
      description: "Launch or refresh campaigns, build momentum, and sharpen consistency."
    },
    {
      month: "Month 3",
      description: "Establish a steady creative rhythm and plan the next quarter."
    }
  ];

  return (
    <section 
      className="w-full bg-[#3f1651] py-12 sm:py-16 lg:py-28"
      style={{
        backgroundImage: "url('/images/img_image_724x1536.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="w-full max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-24 xl:px-36">
        
        {/* Header */}
        <div className="flex justify-center items-center w-full mb-10 sm:mb-12 lg:mb-16">
          <h2 className="text-[40px] sm:text-[60px] lg:text-[80px] xl:text-[90px] font-bebas font-normal leading-[1.1] text-center text-[#ffefef] uppercase">
            Your First Ninety Days
          </h2>
        </div>

        {/* Timeline Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 mb-10 sm:mb-12 lg:mb-16">
          {timelineData?.map((item, index) => (
            <div 
              key={index}
              className="flex flex-col gap-6 sm:gap-8 justify-start items-center w-full bg-[#2a0f3a]/80 border border-[#4a2460] rounded-lg p-6 sm:p-8 lg:p-10 min-h-[200px]"
            >
              {/* Circular Month Badge */}
              <div className="w-20 h-20 sm:w-24 sm:h-24 lg:w-28 lg:h-28 bg-[#9b3dc0] rounded-full flex items-center justify-center shadow-lg">
                <span className="text-[16px] sm:text-[18px] lg:text-[22px] font-bebas font-normal leading-[1.2] text-center text-white uppercase tracking-wide">
                  {item?.month}
                </span>
              </div>
              
              {/* Description */}
              <p className="text-[14px] sm:text-[15px] lg:text-[16px] font-poppins font-normal leading-[1.7] text-center text-[#e4e4e4]">
                {item?.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center items-center w-full">
          <Button
            text="START YOUR FIRST 90 DAYS"
            text_font_size="text-xs sm:text-sm"
            text_font_family="Helvetica"
            text_font_weight="font-medium"
            text_line_height="leading-normal"
            text_text_align="center"
            text_text_transform="uppercase"
            text_color="text-white"
            fill_background_color="bg-[#8923b3]"
            border_border_radius="rounded-full"
            className="w-full sm:w-auto py-4 px-8 sm:px-10 hover:bg-[#7a1f9e] transition-all duration-300 tracking-wider"
            onClick={handleStartTimeline}
          />
          
          <Button
            text="TALK THROUGH YOUR GOALS"
            text_font_size="text-xs sm:text-sm"
            text_font_family="Helvetica"
            text_font_weight="font-medium"
            text_line_height="leading-normal"
            text_text_align="center"
            text_text_transform="uppercase"
            text_color="text-white"
            fill_background_color="bg-transparent"
            border_border_radius="rounded-full"
            className="w-full sm:w-auto py-4 px-8 sm:px-10 border-2 border-white hover:bg-white hover:text-[#3f1651] transition-all duration-300 tracking-wider"
            onClick={handleTalkGoals}
          />
        </div>
      </div>
    </section>
  );
}
